import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

import HeadingSecondary from "../components/ HeadingSecondary";

// Import Swiper styles
import "swiper/swiper.scss";
const SettingFAQ: React.FC<any> = () => {
  return (
    <div className="setting setting--none-padding u-padding-top-small-2">
      <div className="u-margin-top-small-2-5">
        <HeadingSecondary text="درباره ما" fontSize="2.7" />
      </div>

      <div className="setting__aboutus u-margin-bottom-big ">
        <div className="setting__aboutus__title u-padding-left-small-2 u-padding-right-small-2">
          <h4>مدیریت هوشمند بحران های سلامت</h4>
          <p>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
            است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط
            فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد .
          </p>
        </div>
        <div className="setting__aboutus__services u-margin-top-small-1">
          <HeadingSecondary text="خدمات" fontSize="2.7" />
          <div className="services-slider u-padding-right-small-2  ">
            <Swiper spaceBetween={50} slidesPerView={1.5} loop={true}>
              <SwiperSlide>
                <div className="services-slider__box">
                  <div className="services-slider__box__title">سکوی مدیریت حمل و نقل عمومی</div>
                  <div className="services-slider__box__sub-title">پایش، تحلیل و غربالگری</div>
                  <div className="services-slider__box__content">
                    <p>
                      در راستای افزایش امنیت اجتماعی شهروندان در دوران بحران های سلامت، وضعیت سلامت
                      تمامی افراد شاغل در حوزه حمل و نقل عمومی به صورت مستمر و بر خط مورد بررسی قرار
                      میگیرد .
                      <br />
                      شهروندان این امکان را خواهند داشت تا در صورت تمایل از طریق وارد نمودن پلاک
                      وسیله نقلیه در بخش حمل و نقل وضعیت سلامت خدمت دهنده را به صورت لحظه ای و برخط
                      بررسی نمایند .
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="services-slider__box">
                  <div className="services-slider__box__title">سکوی مدیریت حمل و نقل عمومی</div>
                  <div className="services-slider__box__sub-title">پایش، تحلیل و غربالگری</div>
                  <div className="services-slider__box__content">
                    <p>
                      در راستای افزایش امنیت اجتماعی شهروندان در دوران بحران های سلامت، وضعیت سلامت
                      تمامی افراد شاغل در حوزه حمل و نقل عمومی به صورت مستمر و بر خط مورد بررسی قرار
                      میگیرد .
                      <br />
                      شهروندان این امکان را خواهند داشت تا در صورت تمایل از طریق وارد نمودن پلاک
                      وسیله نقلیه در بخش حمل و نقل وضعیت سلامت خدمت دهنده را به صورت لحظه ای و برخط
                      بررسی نمایند .
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="services-slider__box">
                  <div className="services-slider__box__title">سکوی مدیریت حمل و نقل عمومی</div>
                  <div className="services-slider__box__sub-title">پایش، تحلیل و غربالگری</div>
                  <div className="services-slider__box__content">
                    <p>
                      در راستای افزایش امنیت اجتماعی شهروندان در دوران بحران های سلامت، وضعیت سلامت
                      تمامی افراد شاغل در حوزه حمل و نقل عمومی به صورت مستمر و بر خط مورد بررسی قرار
                      میگیرد .
                      <br />
                      شهروندان این امکان را خواهند داشت تا در صورت تمایل از طریق وارد نمودن پلاک
                      وسیله نقلیه در بخش حمل و نقل وضعیت سلامت خدمت دهنده را به صورت لحظه ای و برخط
                      بررسی نمایند .
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="services-slider__box">
                  <div className="services-slider__box__title">سکوی مدیریت حمل و نقل عمومی</div>
                  <div className="services-slider__box__sub-title">پایش، تحلیل و غربالگری</div>
                  <div className="services-slider__box__content">
                    <p>
                      در راستای افزایش امنیت اجتماعی شهروندان در دوران بحران های سلامت، وضعیت سلامت
                      تمامی افراد شاغل در حوزه حمل و نقل عمومی به صورت مستمر و بر خط مورد بررسی قرار
                      میگیرد .
                      <br />
                      شهروندان این امکان را خواهند داشت تا در صورت تمایل از طریق وارد نمودن پلاک
                      وسیله نقلیه در بخش حمل و نقل وضعیت سلامت خدمت دهنده را به صورت لحظه ای و برخط
                      بررسی نمایند .
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div className="setting__aboutus__plans u-margin-bottom-big u-margin-top-small-1">
          <HeadingSecondary text="اهداف" fontSize="2.7" />
          <div className="setting__aboutus__plans__box">
            <h3>۱. پایش، تحلیل و غربالگری</h3>
          </div>
          <div className="setting__aboutus__plans__box">
            <h3>۲. در شرایط بحران های سلامت</h3>
          </div>
          <div className="setting__aboutus__plans__box">
            <h3>۳. تجمیع، پایش و تحلیل اطلاعات</h3>
          </div>
          <div className="setting__aboutus__plans__box">
            <h3>۴. مدیریت هوشمند بحران های سلامت</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingFAQ;
